import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SpinnerCarga } from './components/SpinnerCarga';
import Home from './page';
import NotFound from './pages/NotFound/NotFound';
import ClientServiceP from './services/client/ClientPService';

const ClientGuard = ({ clientSlug: propSlug }) => {
  const { clientSlug: paramSlug } = useParams();
  const clientSlug = propSlug || paramSlug; // Usa prop (subdomain) o param (path)
  const [status, setStatus] = useState('loading'); // 'loading' | 'found' | 'notfound'

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const client = await ClientServiceP.getClientBySlug(clientSlug);
        if (!mounted) return;
        setStatus(client ? 'found' : 'notfound');
      } catch (err) {
        if (!mounted) return;
        setStatus('notfound');
      }
    })();
    return () => { mounted = false; };
  }, [clientSlug]);

  useEffect(() => {
    if (status !== 'found') return;
    // Manifest dinámico del negocio, servido por el backend. Va con la URL absoluta
    // de la API: una ruta relativa ("/api/...") la resolvía el hosting del front, que
    // no tiene backend y devolvía index.html → Chrome Android lo marcaba inválido y
    // en vez de instalar la app creaba un acceso directo. Al ser otro origen, el
    // link necesita crossorigin (el backend ya acepta el origen del front en CORS).
    const api = (process.env.REACT_APP_API || '/api').replace(/\/+$/, '');
    document.querySelector('link[rel="manifest"]')?.remove();
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.crossOrigin = 'anonymous';
    link.href = `${api}/clientsPublic/manifest/${clientSlug}`;
    document.head.appendChild(link);
    return () => link.remove();
  }, [status, clientSlug]);

  if (status === 'loading') {
    return <SpinnerCarga />;
  }

  return status === 'found' ? <Home clientSlug={clientSlug} /> : <NotFound reason="business" slug={clientSlug} />;
};

export default ClientGuard;